/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {withDLSTheme} from '../../theme/withDLSTheme';
import {SecondaryButton as CurrentSecondaryButton} from './current/SecondaryButton';
import {SecondaryButton as LegacySecondaryButton} from './legacy/SecondaryButton';

// Ensures theme-based resolution when importing:
// `import {SecondaryButton} from '@ion/dls/src/components/buttons';`
export const SecondaryButton = withDLSTheme(LegacySecondaryButton, CurrentSecondaryButton);

export default SecondaryButton;
